import { subCompanyChecklistsApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';
import { mapFlatChecklistResultsToChecklistResultModels } from 'utils/checklistFlatStoreAdapter';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const SUB_COMPANY_CHECKLISTS_ACTION_TYPE = createNamedActions('subCompanyChecklists', {
  GET_RESULTS: 'GET_RESULTS',
  RESET_STATE: 'RESET_STATE',
});

// FH-1931/FH-1835: behind `ReadChecklistsFromFlatStore`, reads the FH-1829 flat-store lean endpoint
// and maps it back to the legacy `ChecklistResultModel[]` shape the sub-company selectors already
// consume — the flat read also fixes a real timeout (`includeItems=true` 500s on a large checklist
// via the legacy EF-Include read; see the sub-company flat-store repository tests).
export const getSubCompanyChecklistResultsAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isFlatStoreReadEnabled = selectFeatureFlagByKey(FeatureFlag.ReadChecklistsFromFlatStore)(
      getState(),
    );

    const { data } = isFlatStoreReadEnabled
      ? await subCompanyChecklistsApi.getFlatChecklistResults(params)
      : await subCompanyChecklistsApi.getChecklistResults(params);

    const results = isFlatStoreReadEnabled
      ? mapFlatChecklistResultsToChecklistResultModels(data)
      : data || [];

    return dispatch({
      type: SUB_COMPANY_CHECKLISTS_ACTION_TYPE.GET_RESULTS,
      payload: results,
    });
  },
);

export const recomputeSubCompanyChecklistResultsAction = catchAsyncActionError(
  params => async () => {
    await subCompanyChecklistsApi.recomputeChecklistResults(params);
  },
);

export const setSubCompanyChecklistResultOverridesAction = catchAsyncActionError(
  params => async () => {
    await subCompanyChecklistsApi.setChecklistResultOverrides(params);
  },
);

export const resetSubCompanyChecklistsAction = () => ({
  type: SUB_COMPANY_CHECKLISTS_ACTION_TYPE.RESET_STATE,
});
